import './TemplateSelector.scss';
import React, { useCallback } from 'react';
import { FlightSelect } from '@flybits/design-system';
import { ReactComponent as IconSendGrid } from 'assets/icons/icon-sendgrid.svg';
import { ReactComponent as IconTwilio } from 'assets/icons/icon-twilio.svg';
import { TEmailProviderTemplate, TSMSProviderTemplate } from 'components/FlowBuilder/FlowSidePanels/types';

const MAIN_CLASS = 'template-selector';
const CLASSES = {
  CONTAINER: `${MAIN_CLASS}__container`,
  HEADER: `${MAIN_CLASS}__container__header`,
  HEADER_ICON: `${MAIN_CLASS}__container__header__icon`,
  HEADER_TITLE: `${MAIN_CLASS}__container__header__title`,
  HEADER_TITLE_RED: `${MAIN_CLASS}__container__header__title--red`,
  SELECTOR: `${MAIN_CLASS}__container__selector`,
  FOOTER: `${MAIN_CLASS}__container__footer`,
};

interface TemplateSelectorProps {
  type: 'email' | 'sms';
  templates: TEmailProviderTemplate[] | TSMSProviderTemplate[];
  isTemplateError?: boolean;
  selectedTemplate?: TEmailProviderTemplate | TSMSProviderTemplate | null;
  onTemplateSelect: (template: TEmailProviderTemplate | TSMSProviderTemplate) => void;
}

function TemplateSelector({
  type,
  onTemplateSelect,
  templates,
  isTemplateError,
  selectedTemplate,
}: TemplateSelectorProps) {
  const handleSelectTemplate = useCallback(
    (template: TEmailProviderTemplate | TSMSProviderTemplate) => {
      onTemplateSelect(template);
    },
    [onTemplateSelect],
  );

  return (
    <div className={MAIN_CLASS}>
      <div className={CLASSES.CONTAINER}>
        <div className={CLASSES.HEADER}>
          <div className={CLASSES.HEADER_ICON}>{type === 'email' ? <IconSendGrid /> : <IconTwilio />}</div>
          <div className={CLASSES.HEADER_TITLE}>
            {type === 'email' ? 'SendGrid' : 'SMS'} template
            <span className={CLASSES.HEADER_TITLE_RED}>*</span>
          </div>
        </div>
        <div className={CLASSES.SELECTOR}>
          <FlightSelect
            ariaControlsId="template-selector"
            options={templates}
            selected={selectedTemplate}
            handleOptionClick={handleSelectTemplate}
            hasError={!!isTemplateError}
            errorMessage={
              type === 'email'
                ? 'Unable to fetch this template, please try again later.'
                : `We couldn't retrieve this template at the moment. Please refresh the page or try again later.`
            }
          />
        </div>
        {!isTemplateError && <div className={CLASSES.FOOTER}>The template will define how your {type} will look</div>}
      </div>
    </div>
  );
}

export default TemplateSelector;
